<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>培训经历</h1>
            </el-col>
            <el-col :span="20">
                <div class="resumeContent" v-for="item in resumeInfo.trainingExperienceList" :key="item.id">
                    <el-row>
                        <el-col :span="8">
                            <p><b>{{item.recordName}}</b></p>
                        </el-col>
                        <el-col :span="8">
                            {{item.startTime}} ~ {{item.endTime}}
                        </el-col>
                        <el-col :span="8">
                            {{item.orgName}}
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'TrainingExperience',
        props: ['resumeInfo']
    }
</script>